import { MessageData } from '../interfaces/message-data';
import { MessageType } from '../interfaces/message-type.enum';

export function mapMessage(
  isSuccess: boolean,
  successMessage: string,
  failMessage: string,
): MessageData {
  let msgType = MessageType.WARNING;
  let msg = failMessage;
  if (isSuccess) {
    msg = successMessage;
    msgType = MessageType.SUCCESS;
  }

  return {
    msg,
    msgType,
  };
}
